import * as actionTypes from './actionTypes';
import * as ShipConstants from '../../Global/Constants';

export const updateMessageState = (type, msg) => {
	return {
		type: actionTypes.MESSAGES,
		msgType : type,
		msg: msg
	};
}

export const errorBoundaryMsg = (bool) => {
	return {
		type: actionTypes.BOUNDARY_WARNING,
		bool: bool
	};
}

export const clearMessage = () => {
	return {
		type: actionTypes.CLEAR_MESSAGES
	};
}

export const succMessage = (msg) => {
	return dispatch => {
		dispatch(updateMessageState(ShipConstants.SUCCESS_MSG, msg));
		setTimeout(() => {
		    setTimeout(() => dispatch(clearMessage()));
	  	}, 5000);
	};
}

export const failMessage = (msg) => {
	return dispatch => {
		dispatch(updateMessageState(ShipConstants.FAIL_MSG, msg));
		setTimeout(() => {
		    setTimeout(() => dispatch(clearMessage()));
	  	}, 5000);
	};
}

export const warningMessage = (msg) => {
	return dispatch => {
		dispatch(updateMessageState(ShipConstants.WARN_MSG, msg));
		setTimeout(() => {
		    setTimeout(() => dispatch(clearMessage()));
	  	}, 5000);
	};
}

export const infoMessage = (msg) => {
	return dispatch => {
		dispatch(updateMessageState(ShipConstants.INFO_MSG, msg));
		setTimeout(() => {
		    setTimeout(() => dispatch(clearMessage()));
	  	}, 5000);
	};
}